import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { Link } from "react-router-dom";
import Sidebar from "../../components/Sidebar";
import Header from "../../components/Header";
import "./DashboardOverviewMerchantsInformation.css";

const DashboardOverviewMerchantsInformation = () => {
  const [showQRPopup, setShowQRPopup] = useState(false);

  const handleQRClick = () => {
    if (window.innerWidth <= 768) {
      setShowQRPopup(true);
    }
  };

  const [activeTab, setActiveTab] = useState('null');

  const renderTabContent = () => {
    switch (activeTab) {
      case "subscription plan":
        return <p>This is the Subscription Plan content.</p>;
      case "payment history":
        return <p>This is the Payment History content.</p>;
      case "employees":
        return <p>This is the Employees section content.</p>;
      case "products":
        return <p>This is the Products section content.</p>;
      case "coupons":
        return <p>This is the Coupons section content.</p>;
      case "customers":
        return <p>This is the Customers section content.</p>;
      case "imcome & forecast":
        return <p>This is the Income & Forecast content.</p>;
      default:
        return null;
    }
  };


  useEffect(() => {
    document.title = `Dashboard-Overview-Merchants-information | bluefaucet`;
    document.getElementById("bodywrap").className = "infr";
  }, []);

  return (
    <>
      <div className="container-fluid">
        <div className="row">
          <Sidebar />

          <div className="col-md-9 col-lg-9 col-xl-10 col-xxl-10 ">
            <Header />
            <div className="row">
              <div className="content">
                <div className="row">
                  <div className="col-12">
                    <h1>Merchant Information</h1>
                    <div className="vnfro">
                      <div className="d-flex align-items-center justify-content-between gap-3 flex-wrap mb-4 kjuk">
                        {/* Profile Image */}
                        <div className="d-flex align-items-center gap-3">
                          <div className="leki">
                            <img
                              src={process.env.REACT_APP_BASE_URL + 'assests/images/elii.png'}
                              alt="Profile"
                              className="img-fluid"
                            />
                            <div onClick={handleQRClick} className="d-block d-md-none hello-qr mt-2">
                              QR <img src={process.env.REACT_APP_BASE_URL + 'assests/images/qeo.png'} alt="qr" className="img-fluid houi" />
                            </div>
                            <Modal
                              show={showQRPopup}
                              onHide={() => setShowQRPopup(false)}
                              centered
                              className="d-md-none"
                            >
                              <Modal.Header className="pb-0 border-bottom-0" closeButton>
                                <Modal.Title>QR Codes</Modal.Title>
                              </Modal.Header>
                              <Modal.Body className="text-center">
                                <img
                                  src={process.env.REACT_APP_BASE_URL + 'assests/images/qr.png'}
                                  alt="QR 1"
                                  className="img-fluid"
                                />
                                <img
                                  src={process.env.REACT_APP_BASE_URL + 'assests/images/qr.png'}
                                  alt="QR 2"
                                  className="img-fluid"
                                />
                              </Modal.Body>
                            </Modal>
                          </div>

                          {/* Store Info */}
                          <div className="infea">
                            <p>Store Name</p>
                            <h5>John’s Electronics</h5>
                            <div className="ids">ID# M-2302</div>
                            <div className="aank d-flex"><div className="date">Join Date:</div>23-06-2024</div>
                            <div className="aank d-flex"><div className="date oji">Address:</div>6391 Elgin St. Celina, Delaware 10299</div>
                          </div>
                        </div>

                        {/* QR Codes */}
                        <div className="d-flex d-none d-md-block">
                          <img
                            src={process.env.REACT_APP_BASE_URL + 'assests/images/qr.png'}
                            alt="QR 1"
                            className="img-fluid"
                          />
                          <img
                            src={process.env.REACT_APP_BASE_URL + 'assests/images/qr.png'}
                            alt="QR 2"
                            className="img-fluid"
                          />
                        </div>
                      </div>

                      {/* Desktop */}
                      <div className="row mt-3 d-none d-md-flex">
                        <div className="col-md-4">
                          <div className="d-flex mb-3">
                            <div className="col-5 text-start tatly">Owner Name:</div>
                            <div className="col-6 latly">John Doe</div>
                          </div>

                          <div className="d-flex mb-3">
                            <div className="col-5 text-start tatly">DOB:</div>
                            <div className="col-6 latly">10-09-1992</div>
                          </div>

                          <div className="d-flex mb-3">
                            <div className="col-5 text-start tatly">Category:</div>
                            <div className="col-6 latly">Lorem Ipsum</div>
                          </div>

                          <div className="d-flex mb-3">
                            <div className="col-5 text-start tatly">Stripe account:</div>
                            <div className="col-6 latly">2155*********215</div>
                          </div>

                          <div className="d-flex mb-3">
                            <div className="col-5 text-start tatly">Credit Card account:</div>
                            <div className="col-6 latly">2155*********215</div>
                          </div>

                          <div className="d-flex mb-3">
                            <div className="col-5 text-start tatly">Bank account:</div>
                            <div className="col-6 latly">2155*********215</div>
                          </div>
                        </div>

                        <div className="col-md-4">
                          <div className="d-flex mb-3">
                            <div className="col-5 text-start tatly">Phone Number</div>
                            <div className="col-6 latly">+1 (469) 532-2382</div>
                          </div>

                          <div className="d-flex mb-3">
                            <div className="col-5 text-start tatly">Salesperson Name</div>
                            <div className="col-6 latly"><Link to={process.env.REACT_APP_BASE_URL + 'merchant-subscription'} className="table-link">John Smith</Link></div>
                          </div>

                          <div className="d-flex mb-3">
                            <div className="col-5 text-start tatly">Subcategory</div>
                            <div className="col-6 latly">Lorem Ipsum</div>
                          </div>

                          <div className="d-flex mb-3">
                            <div className="col-5 text-start tatly">Status</div>
                            <div className="col-6 latly">Free Trial</div>
                          </div>
                        </div>

                        <div className="col-md-4">
                          <div className="d-flex mb-3">
                            <div className="col-5 text-start tatly">Email</div>
                            <div className="col-6 latly">Johndoe131@example.com</div>
                          </div>

                          <div className="d-flex mb-3">
                            <div className="col-5 text-start tatly">No. of Customers</div>
                            <div className="col-6 latly">215</div>
                          </div>

                          <div className="d-flex mb-3">
                            <div className="col-5 text-start tatly">KYC</div>
                            <div className="col-6 latly">Verified</div>
                          </div>
                        </div>
                      </div>

                      {/* Mobile */}
                      <div className="row mt-3 d-md-none">
                        <div className="col-md-4 col-6 mb-3">
                          <div className="text-start tatly">Owner Name</div>
                          <div className="latly">John Doe</div>
                        </div>
                        <div className="col-md-4 col-6 mb-3">
                          <div className="text-start tatly">Phone Number</div>
                          <div className="latly">+1 (469) 532-2382</div>
                        </div>

                        <div className="col-md-4 col-6 mb-3">
                          <div className="text-start tatly">Email</div>
                          <div className="latly">Johndoe131@example.com</div>
                        </div>
                        <div className="col-md-4 col-6 mb-3">
                          <div className="text-start tatly">DOB</div>
                          <div className="latly">10-09-1992</div>
                        </div>

                        <div className="col-md-4 col-6 mb-3">
                          <div className="text-start tatly">Salesperson Name</div>
                          <div className="latly"><Link to="/merchant-subscription" className="table-link">John Smith</Link></div>
                        </div>
                        <div className="col-md-4 col-6 mb-3">
                          <div className="text-start tatly">No. of Customers</div>
                          <div className="latly">215</div>
                        </div>

                        <div className="col-md-4 col-4 mb-3">
                          <div className="text-start tatly">Category</div>
                          <div className="latly">Lorem Ipsum</div>
                        </div>
                        <div className="col-md-4 col-4 mb-3">
                          <div className="text-start tatly">Subcategory</div>
                          <div className="latly">Lorem Ipsum</div>
                        </div>

                        <div className="col-md-4 col-4 mb-3">
                          <div className="text-start tatly">KYC</div>
                          <div className="latly">Verified</div>
                        </div>
                        <div className="col-md-4 col-6 mb-3">
                          <div className="text-start tatly">Stripe account</div>
                          <div className="latly">2155*********215</div>
                        </div>

                        <div className="col-md-4 col-6 mb-3">
                          <div className="text-start tatly">Credit Card account</div>
                          <div className="latly">2155*********215</div>
                        </div>
                        <div className="col-md-4 col-6 mb-3">
                          <div className="text-start tatly">Bank account</div>
                          <div className="latly">2155*********215</div>
                        </div>

                        <div className="col-md-4 col-6 mb-3">
                          <div className="text-start tatly">Status</div>
                          <div className="latly">Free Trial</div>
                        </div>
                      </div>

                      {/* Footer Tabs (Nav Tabs Style) */}
                      <ul className="nav nav-tabs mt-4 d-none d-md-flex gap-2">
                        {[
                          { key: "subscription plan", label: "Subscription Plan" },
                          { key: "payment history", label: "Payment History" },
                          { key: "employees", label: "Employees" },
                          { key: "products", label: "Products" },
                          { key: "coupons", label: "Coupons" },
                          { key: "customers", label: "Customers" },
                          { key: "income & forecast", label: "Income & Forecast" },
                        ].map((tab) => (
                          <li className="nav-item" key={tab.key}>
                            <button
                              className={`nav-link ${activeTab === tab.key ? "active" : ""}`}
                              onClick={() => setActiveTab(tab.key)}
                            >
                              {tab.label}
                            </button>
                          </li>
                        ))}
                      </ul>

                      <div className="d-md-none overflow-auto">
                        <ul className="nav nav-tabs flex-nowrap text-nowrap">
                          {[
                            { key: "subscription plan", label: "Subscription Plan" },
                            { key: "payment history", label: "Payment History" },
                            { key: "employees", label: "Employees" },
                            { key: "products", label: "Products" },
                            { key: "coupons", label: "Coupons" },
                            { key: "customers", label: "Customers" },
                            { key: "income & forecast", label: "Income & Forecast" },
                          ].map((tab) => (
                            <li className="nav-item" key={tab.key}>
                              <button
                                className={`nav-link ${activeTab === tab.key ? "active" : ""}`}
                                onClick={() => setActiveTab(tab.key)}
                              >
                                {tab.label}
                              </button>
                            </li>
                          ))}
                        </ul>
                      </div>

                    </div>
                    <div className="mt-4">{renderTabContent()}</div>

                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default DashboardOverviewMerchantsInformation;